import React from 'react';
import PropTypes from 'prop-types';
import styles from './header.scss';

class QuestionSubHeader extends React.Component {
    static propTypes = {
        assessment: PropTypes.object.isRequired,
    };

    render() {
        return (
            <div className={styles.tocHeaderWrapper}>
                <div className={styles.statusSection}>
                    <div className={styles.statusText}>
                        <h1>{this.props.assessment.title}</h1>
                    </div>
                </div>
            </div>
        );
    }
}

export default QuestionSubHeader;
